import React, { useRef, useState } from 'react';
import * as styles from './index.module.less';
import { IHeaderNavDropdown, IHeaderNavLink } from '@/layout/constants';
import NavbarItemWrapper from '../navbar-item-wrapper';
import DropdownContainer from '../dropdown-container';

interface IProps {
  data: IHeaderNavDropdown | IHeaderNavLink;
}

const NavDropdownWrapper = ({ data }: IProps) => {
  const { label, type } = data;
  const dropdownContainerRef = useRef<HTMLDivElement>(null);
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const handleNavbarHover = () => {
    setIsDropdownActive(true);

    const dropdownContainerDOM = dropdownContainerRef.current;
    const dropdownInnerDOM = dropdownContainerDOM?.children?.[0] as HTMLDivElement;

    dropdownContainerDOM.style.transitionDelay = '0s';
    dropdownContainerDOM.style.maxHeight = dropdownInnerDOM?.scrollHeight + 'px';
    dropdownInnerDOM.style.transitionDelay = '0.1s';
    dropdownInnerDOM.style.opacity = '1';
  };

  const handleNavBarUnHover = () => {
    setIsDropdownActive(false);

    const dropdownContainerDOM = dropdownContainerRef.current;
    const dropdownInnerDOM = dropdownContainerDOM?.children?.[0] as HTMLDivElement;

    dropdownContainerDOM.style.transitionDelay = '0.1s';
    dropdownContainerDOM.style.maxHeight = '0px';
    dropdownInnerDOM.style.transitionDelay = '0s';
    dropdownInnerDOM.style.opacity = '0';
  };

  return (
    <div
      key={label}
      className={styles.router_item}
      onMouseOver={type === 'dropdown' ? handleNavbarHover : () => {}}
      onMouseLeave={type === 'dropdown' ? handleNavBarUnHover : () => {}}
    >
      <NavbarItemWrapper
        label={label}
        link={type === 'link' ? data.link : undefined}
        isDropdownActive={isDropdownActive}
      />
      {type === 'dropdown' && <DropdownContainer ref={dropdownContainerRef} data={data.dropdownList} />}
    </div>
  );
};
export default NavDropdownWrapper;
